import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import {
  ReservationCreateOrUpdateRequest,
  ReservationDetail,
  ReservationListParams,
  ReservationListResponse,
} from '@models/reservations';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReservationsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getReservations(params: ReservationListParams): Observable<ReservationListResponse> {
    let httpParams = new HttpParams().set('page', params.page).set('pageSize', params.pageSize);

    const setIf = (key: string, value: string | number | boolean | null | undefined) => {
      if (value != null && value !== '') httpParams = httpParams.set(key, value);
    };

    setIf('search', params.search);
    setIf('reservationNumber', params.reservationNumber);
    setIf('customer', params.customer);
    setIf('companyName', params.companyName);
    setIf('financialNumber', params.financialNumber);
    setIf('emergencyContact', params.emergencyContact);
    setIf('siteId', params.siteId);
    setIf('locale', params.locale);
    setIf('waterId', params.waterId);
    setIf('statusId', params.statusId);
    setIf('reservationType', params.reservationType);
    setIf('paymentStatus', params.paymentStatus);
    setIf('lastMinute', params.lastMinute);
    setIf('insurance', params.insurance);
    setIf('dog', params.dog);
    setIf('wholeWater', params.wholeWater);
    setIf('financial', params.financial);
    setIf('arrivalFrom', params.arrivalFrom);
    setIf('arrivalTo', params.arrivalTo);
    setIf('departureFrom', params.departureFrom);
    setIf('departureTo', params.departureTo);
    setIf('createdFrom', params.createdFrom);
    setIf('createdTo', params.createdTo);
    setIf('invoiceOneFrom', params.invoiceOneFrom);
    setIf('invoiceOneTo', params.invoiceOneTo);
    setIf('invoiceTwoFrom', params.invoiceTwoFrom);
    setIf('invoiceTwoTo', params.invoiceTwoTo);
    setIf('cancelledFrom', params.cancelledFrom);
    setIf('cancelledTo', params.cancelledTo);
    setIf('retailPriceMin', params.retailPriceMin);
    setIf('retailPriceMax', params.retailPriceMax);
    setIf('purchasePriceMin', params.purchasePriceMin);
    setIf('purchasePriceMax', params.purchasePriceMax);
    setIf('payedDownPayment', params.payedDownPayment);
    setIf('downPaymentPriceMin', params.downPaymentPriceMin);
    setIf('downPaymentPriceMax', params.downPaymentPriceMax);
    setIf('payedRestPayment', params.payedRestPayment);
    setIf('restPaymentPriceMin', params.restPaymentPriceMin);
    setIf('restPaymentPriceMax', params.restPaymentPriceMax);
    setIf('financialNumberBuy', params.financialNumberBuy);

    return this.http.get<ReservationListResponse>(`${this.baseUrl}/api/crm/reservations`, {
      params: httpParams,
    });
  }

  getReservation(id: number): Observable<ReservationDetail> {
    return this.http.get<ReservationDetail>(`${this.baseUrl}/api/crm/reservations/${id}`);
  }

  createReservation(data: ReservationCreateOrUpdateRequest): Observable<ReservationDetail> {
    return this.http.post<ReservationDetail>(`${this.baseUrl}/api/crm/reservations`, data);
  }

  updateReservation(id: number, data: ReservationCreateOrUpdateRequest): Observable<ReservationDetail> {
    return this.http.put<ReservationDetail>(`${this.baseUrl}/api/crm/reservations/${id}`, data);
  }
}
